module.exports = __webpack_public_path__ + "static/img/pic_16@2x.78929db7.png";